import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useAuth } from "../context/AuthContext";

const MySwal = withReactContent(Swal);

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { saveToken } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsLoading(true);

    if (!email || !password) {
      MySwal.fire({
        icon: "error",
        title: "Missing Fields",
        text: "Email and password are required",
        confirmButtonColor: "#B39359",
      });
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://ligasos-laravel.ligasos.co/api/login",
        { email, password }
      );

      if (response.status !== 200) {
        throw new Error("Unexpected response status: " + response.status);
      }

      const { token, user } = response.data;
      if (!token || !user?.id) {
        throw new Error("Invalid response data");
      }

      saveToken(token, user.id, user.name, user.email);
      MySwal.fire({
        icon: "success",
        title: "Success!",
        text: `Welcome back, ${user.name}!`,
        confirmButtonColor: "#B39359",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        navigate("/profile/dashboard");
      });
    } catch (err) {
      MySwal.fire({
        icon: "error",
        title: "Login Failed",
        text:
          err.response?.data?.message ||
          err.message ||
          "Please check your credentials.",
        confirmButtonColor: "#B39359",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-[#0B2C3D] p-8 sm:p-10 rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-500 hover:shadow-2xl">
        <div className="flex justify-center mb-8">
          <img
            src={require("../../assets/logo/logo.svg").default}
            alt="Logo"
            className="h-12 w-auto"
          />
        </div>
        <h2 className="text-3xl font-extrabold text-center text-white mb-6 tracking-tight">
          Sign In
        </h2>
        {error && (
          <p className="text-red-400 text-sm text-center mb-4 font-medium">
            {error}
          </p>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-white"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              className="mt-1 w-full p-3 rounded-lg border border-[#1A4A5B] bg-[#0B2C3D] text-white focus:border-[#B39359] focus:ring-2 focus:ring-[#B39359] outline-none transition-colors duration-300 placeholder-gray-400"
              placeholder="Enter your email"
            />
          </div>
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-white"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              className="mt-1 w-full p-3 rounded-lg border border-[#1A4A5B] bg-[#0B2C3D] text-white focus:border-[#B39359] focus:ring-2 focus:ring-[#B39359] outline-none transition-colors duration-300 placeholder-gray-400"
              placeholder="Enter your password"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#B39359] text-white font-semibold py-3 rounded-lg hover:bg-[#D4A373] transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}